import React from "react";

export function Healthz() {
  const env = window._env_ || {};

  // List of expected environment variables
  const expectedVars = [
    { key: "REACT_APP_STRIPE_ENV", description: "Stripe environment (test/production)" },
    { key: "AUTH_CLIENT_ID", description: "Azure AD Client ID" },
    { key: "AUTH_AUTHORITY", description: "Azure AD Authority URL" },
    { key: "MERCHANT_CONFIGURATION_BASE_URI", description: "Merchant Configuration API base URL" },
    { key: "MERCHANT_INVITES_ENDPOINT", description: "Merchant invites endpoint path" },
    { key: "PARTNERS_ENDPOINT", description: "Partners endpoint path" },
    { key: "SCOPE_INVITES_READ_ALL", description: "OAuth scope for reading invites" },
    { key: "ENVIRONMENT", description: "Environment name (Development/Staging/Production)" },
  ];

  const getStatus = (value) => {
    if (value === undefined || value === null || value === "") {
      return { status: "missing", className: "text-danger" };
    }
    return { status: "ok", className: "text-success" };
  };

  const allConfigured = expectedVars.every(
    (v) => env[v.key] !== undefined && env[v.key] !== null && env[v.key] !== ""
  );

  return (
    <div className="container mt-4">
      <h1>Health Check</h1>

      <div className={`alert ${allConfigured ? "alert-success" : "alert-warning"} mt-3`}>
        <strong>Status:</strong> {allConfigured ? "Healthy - All environment variables configured" : "Warning - Some environment variables are missing"}
      </div>

      <h2 className="mt-4">Environment Variables</h2>
      <p className="text-muted">
        These values are loaded from <code>window._env_</code> (injected at container startup via env-config.js)
      </p>

      <table className="table table-striped mt-3">
        <thead>
          <tr>
            <th>Variable</th>
            <th>Status</th>
            <th>Value</th>
            <th>Description</th>
          </tr>
        </thead>
        <tbody>
          {expectedVars.map((variable) => {
            const value = env[variable.key];
            const { status, className } = getStatus(value);

            // Mask sensitive values partially
            const displayValue = value
              ? variable.key.includes("CLIENT_ID") || variable.key.includes("SCOPE")
                ? `${value.substring(0, 8)}...${value.substring(value.length - 4)}`
                : value
              : "NOT SET";

            return (
              <tr key={variable.key}>
                <td><code>{variable.key}</code></td>
                <td className={className}>
                  <strong>{status.toUpperCase()}</strong>
                </td>
                <td>
                  <code>{displayValue}</code>
                </td>
                <td>{variable.description}</td>
              </tr>
            );
          })}
        </tbody>
      </table>

      <h2 className="mt-4">Raw window._env_ Object</h2>
      <pre className="bg-light p-3 rounded">
        {JSON.stringify(env, null, 2)}
      </pre>

      <div className="mt-4 text-muted">
        <small>
          Page loaded at: {new Date().toISOString()}
        </small>
      </div>
    </div>
  );
}
